import type { ChatSession } from '../types/chat';

const CHAT_HISTORY_KEY = 'ai_chat_history';

export const loadChatHistory = (): ChatSession[] => {
  try {
    const raw = localStorage.getItem(CHAT_HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as ChatSession[];
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
};

export const saveChatHistory = (chats: ChatSession[]): void => {
  try {
    localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(chats));
  } catch {
    // Ignore write errors (e.g., storage full or disabled).
  }
};
